import { ArrowLeftOutlined, ArrowUpOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Row,
  Select,
  Space,
  theme,
  InputNumber,
} from "antd";
import moment from "moment";
import React, { useState, useCallback, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SUCCESS_CODE, ERR_0022 } from "../../../lib/const";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useCountry from "../../../lib/hooks/useCountry";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../lib/hooks/useMasterData";
import useEState from "../../../lib/hooks/useEState";
import {
  DATA_MASTER_DATA_TYPE,
  ESTATE_TYPE,
  WORK_PERIOD,
} from "../../../lib/const";
import { routes } from "../../../routes";
import WithSidebar from "../../../templates/withSidebar";
import { updateVisit, getListVisitById } from "../../../services/customerVisit";

import "./style.css";

const { useToken } = theme;
const { Option } = Select;

export const EditVisit = () => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const [lineOfWork] = useLineOfWork();
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);
  const [estates, estateList] = useEState();
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const params = useParams();
  const navigate = useNavigate();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [countries] = useCountry();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [failTitle, setFailTitle] = useState("");
  const [failSubtitle, setFailSubtitle] = useState("");
  const [data, setData] = useState({});
  const [year, setYear] = useState(null);
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];

  const months = [
    {
      value: 10,
      name: "ตุลาคม",
    },
    {
      value: 11,
      name: "พฤศจิกายน",
    },
    {
      value: 12,
      name: "ธันวาคม",
    },
    {
      value: 1,
      name: "มกราคม",
    },
    {
      value: 2,
      name: "กุมภาพันธ์",
    },
    {
      value: 3,
      name: "มีนาคม",
    },
    {
      value: 4,
      name: "เมษายน",
    },
    {
      value: 5,
      name: "พฤษภาคม",
    },
    {
      value: 6,
      name: "มิถุนายน",
    },
    {
      value: 7,
      name: "กรกฎาคม",
    },
    {
      value: 8,
      name: "สิงหาคม",
    },
    {
      value: 9,
      name: "กันยายน",
    },
  ];

  const onFinish = async (values) => {
    const request = {
      yearOfBudget: values.yearOfBudget,
      lineOfWork: values.lineOfWork,
      lineOfWorkNameTh: values.lineOfWorkNameTh,
      lineOfWorkNameEn: values.lineOfWorkNameEn,
      estateId: values.estateId,
      estateNameTh: values.estateNameTh,
      estateNameEn: values.estateNameEn,
      customerGroupByAge: values.customerGroupByAge,
      totalFactory: values.totalFactory,
      octAmount: values.octAmount,
      novAmount: values.novAmount,
      decAmount: values.decAmount,
      janAmount: values.janAmount,
      febAmount: values.febAmount,
      marAmount: values.marAmount,
      aprAmount: values.aprAmount,
      mayAmount: values.mayAmount,
      junAmount: values.junAmount,
      julAmount: values.julAmount,
      augAmount: values.augAmount,
      sepAmount: values.sepAmount,
    };

    const res = await updateVisit(params.id, request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.customer_tab_visit);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setFailTitle("ชุดการเยี่ยมชมดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
        setFailSubtitle("โปรดทำรายการอีกครั้ง");
      } else {
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchVisitById = useCallback(
    async (id) => {
      const res = await getListVisitById(id);
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);

        form.setFieldsValue({
          yearOfBudget: objectValue?.yearOfBudget,
          lineOfWork: objectValue?.lineOfWork,
          lineOfWorkNameTh: objectValue?.lineOfWorkNameTh,
          lineOfWorkNameEn: objectValue?.lineOfWorkNameEn,
          estateId: objectValue?.estateId,
          estateNameTh: objectValue?.estateNameTh,
          estateNameEn: objectValue?.estateNameEn,
          customerGroupByAge: objectValue?.customerGroupByAge,
          totalFactory: objectValue?.totalFactory,
          octAmount: objectValue?.octAmount,
          novAmount: objectValue?.novAmount,
          decAmount: objectValue?.decAmount,
          janAmount: objectValue?.janAmount,
          febAmount: objectValue?.febAmount,
          marAmount: objectValue?.marAmount,
          aprAmount: objectValue?.aprAmount,
          mayAmount: objectValue?.mayAmount,
          junAmount: objectValue?.junAmount,
          julAmount: objectValue?.julAmount,
          augAmount: objectValue?.augAmount,
          sepAmount: objectValue?.sepAmount,
        });
      }
    },
    [setData]
  );

  useEffect(() => {
    fetchVisitById(params.id);
  }, [params.id, fetchVisitById]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_visit);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลการเยี่ยมชม",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_visit);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลการเยี่ยมชม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="ปีงบประมาณ"
                        name={"yearOfBudget"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          maxTagCount={"responsive"}
                          onChange={() => {
                            let arr = form.getFieldValue().yearOfBudget;
                            setYear(arr);
                          }}
                          value={year}
                        >
                          {yearArray.map((item) => (
                            <Option value={parseInt(item) + 543}>
                              {parseInt(item) + 543}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        label="สายปฏิบัติงาน"
                        name={"lineOfWork"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือกสายปฏิบัติงาน"
                        >
                          {lineOfWork.map((item) => (
                            <Option value={item.lineOfWork}>
                              {item.nameTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="นิคมอุตสาหกรรม"
                        name={"estateId"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          maxTagCount={"responsive"}
                          style={{
                            width: "100%",
                          }}
                          placeholder="นิคมอุตสาหกรรม"
                        >
                          {estateList.map((item) => (
                            <Option value={item.estateId}>
                              {item.estateNameTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="กลุ่มลูกค้าตามอายุ"
                        name={"customerGroupByAge"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                        >
                          {workPeriod.map((item) => (
                            <Option value={item.dataId}>
                              {item.dataDetailTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="จำนวนรวมโรงงาน"
                        name={"totalFactory"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ต.ค."}
                        name={"octAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"พ.ย."}
                        name={"novAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ธ.ค."}
                        name={"decAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ม.ค."}
                        name={"janAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ก.พ."}
                        name={"febAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"มี.ค."}
                        name={"marAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"เม.ย."}
                        name={"aprAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"พ.ค."}
                        name={"mayAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"มิ.ย."}
                        name={"junAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ก.ค."}
                        name={"julAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ส.ค."}
                        name={"augAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={"ก.ย."}
                        name={"sepAmount"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="กรุณากรอกข้อมูล"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal 
        open={failModal} 
        setOpen={setFailModal}
        title={failTitle ? failTitle : ""}
        subTitle={failSubtitle ? failSubtitle : ""}
        setErrMsg={setFailSubtitle}
      />
    </WithSidebar>
  );
};
